/**
 * @file export.ts
 * @description Сервис для экспорта данных из Task Manager. Обеспечивает экспорт задач, проектов, отчетов и другой информации в различные форматы файлов (Excel, CSV, PDF) с возможностью настройки параметров экспорта.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js', 'axios']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import { TApiData } from '@src/types';
import { postFile } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const ExportService = {
    /**
     * Получает файл экспорта по указанному типу
     * @param {string} name - Название типа экспорта и формата файла
     * @param {TApiData} body - Данные и параметры для экспорта
     * @param {TApiData} params - Дополнительные параметры запроса экспорта
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с файлом экспорта или ошибкой
     */
    getFile: async (name: string, body?: TApiData, params?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postFile(`export/${name}`, body, params);
    }
};
